import { render, staticRenderFns } from "./SPIFProfileAbout.vue?vue&type=template&id=0ca62d5d"
import script from "./SPIFProfileAbout.vue?vue&type=script&lang=js"
export * from "./SPIFProfileAbout.vue?vue&type=script&lang=js"
import style0 from "./SPIFProfileAbout.vue?vue&type=style&index=0&id=0ca62d5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports